import { useQuery } from "@tanstack/react-query"
import { versionApi } from "@/services/version-api"
import { APP_VERSION } from "@/version"

export function useVersionInfo() {
  return useQuery({
    queryKey: ["version-info"],
    queryFn: async () => {
      const info = await versionApi.getVersionInfo()
      return { ...info, reportingManagerVersion: APP_VERSION }
    },
    staleTime: Infinity, // Version info doesn't change during session
  })
}
